import ProtectedRoute from "@components/ProtectedRoute";
import { useIsInclude } from "../../RoutersCst";
import DashboardPage from "@pages/Contents/Dashboard";
import useDashboardEnablement from "./sections/DashboardEnablement";
import useDashboardAssociateCorporate from "./sections/DashboardAssociateCorporate";

const useDashboardRoutes = () => {
  const { isInclude } = useIsInclude();

  const useDashboardEnablementRoutes = useDashboardEnablement();
  const useDashboardCorporateAssociationRoutes =
    useDashboardAssociateCorporate();

  return {
    path: "dashboard",
    children: [
      {
        index: false,
        path: "",
        element: (
          <ProtectedRoute
            isAllowed={isInclude("smartconfigurator.quicksight.read")}
          >
            <DashboardPage />
          </ProtectedRoute>
        ),
      },
      useDashboardEnablementRoutes,
      useDashboardCorporateAssociationRoutes,
    ],
  };
};
export default useDashboardRoutes;
